import EmailHighlighting from './email_highlighting';
export default EmailHighlighting;



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/text_editor/plugins/email_highlighting/index.js